module.exports = {"pathContext":{"slug":"/offre-emploi"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/offre-emploi.json
// module id = 574
// module chunks = 235638047987920